import styled from 'styled-components';
import { DefaultParagraphMediumFactory } from '../../Typograph/Typograph.Style';

export const CheckboxContainer = styled.label(({ theme }) => ({
  cursor: "pointer",
  gridTemplateColumns: "0.1fr 2fr",
  display: "grid",
  [theme.breakpoint.lg()]: {
    alignItems: "center",
    display: "flex",
  },
}))

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  width: 18px;
  height: 18px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  display: block;
  white-space: nowrap;
`;

export const StyledCheckbox = styled.div`
  width: 18px;
  height: 18px;
  background: ${({ checked }) => (checked ? 'blue' : 'white')};
  border: 2px solid ${({ checked }) => (checked ? 'blue' : '#b0bec5')};
  border-radius: 3px;
  transition: all 150ms;
  align-items: center;
  justify-content: center;
  display: flex;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 0, 255, 0.2);
  }

  &:hover {
    border-color: #42a5f5;
  }
`;

export const Text = styled.span(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
  marginLeft: "8px",
  color: "#424242",
}))

